import { Box, Circle, Text, Image } from '@chakra-ui/react';
import star from '../Assets/Icons/star.png';

import React from 'react';
import BlockCard from './BlockCard';
import { useSelectedCourse } from '../../../context/SelectedCourseContext';
import { useDomainConfig } from '../../../hooks/useDomainConfig';
import { SAGEX_ORG_KEY } from '../../../utils/segexOrgName';
interface Props {
	roadmapPublishedItem: any;
}
const Roadmap = ({ roadmapPublishedItem }: Props) => {
	const { selectedCourse } = useSelectedCourse();
	const { data } = useDomainConfig({ uiHost: window.location.host });
	console.log('roadmapPublishedItem', roadmapPublishedItem);
	console.log('Blocks data:', roadmapPublishedItem?.entity?.blocks);
	const isSagex = data?.key === SAGEX_ORG_KEY;
	const getProfessionByCourseName = (courseName: string) => {
		if (courseName === 'FSD_GEN_AI - SAGE') {
			return 'Software Developer';
		}
		return courseName;
	};
	return (
		<Box pb="100px">
			<Box overflowY="auto">
				{/* Top Banner */}
				<Box
					minH={{ base: '4.25rem', md: '56px' }}
					display="flex"
					alignItems="center"
					bg="#7261DF"
					borderRadius="8px"
					position="relative"
					overflow="hidden"
					p={'10px 50px 10px 12px'}
				>
					{!isSagex ? (
						<Text textStyle={{ base: 'body2', md: 'h6' }} color="#FFFFFF" wordBreak={'break-word'}>
							Practice and{' '}
							<Text as="span" style={{ fontWeight: '600' }} color="#FFDB66">
								earn badges
							</Text>{' '}
							to unlock better job opportunities in various companies.
						</Text>
					) : (
						<Text textStyle={{ base: 'body2', md: 'h6' }} color="#FFFFFF" wordBreak={'break-word'}>
							Complete the modules to become a {getProfessionByCourseName(selectedCourse.label)}
						</Text>
					)}
					<Circle position="absolute" top={-3} right={-3} bg="#FFF3CC" size="3.5rem" transformOrigin="0 0">
						<Image
							src={star}
							alt="star"
							style={{
								width: '40%',
								height: '40%',
								marginTop: '1.2rem',
								display: 'block',
								margin: 'auto',
							}}
						/>
					</Circle>
				</Box>

				<Box mt="20px" display={'flex'} flexWrap="wrap" gap="16px">
					{roadmapPublishedItem?.entity?.blocks?.map((block: any, index: number) => {
						return <BlockCard blockData={block} />;
					})}
				</Box>
			</Box>
		</Box>
	);
};

export default Roadmap;
